import { render, staticRenderFns } from "./MassiveForm.vue?vue&type=template&id=dddcb122&scoped=true&"
import script from "./MassiveForm.vue?vue&type=script&lang=js&"
export * from "./MassiveForm.vue?vue&type=script&lang=js&"
import style0 from "./MassiveForm.vue?vue&type=style&index=0&id=dddcb122&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dddcb122",
  null
  
)

export default component.exports